import { apiFetch } from '@/lib/api-client/client';

/** Matches the Worker's /api/bot response exactly (proxies bridge/server.py's /bridge/v1/bot). */
export interface BotInfo {
  id: string;
  username: string;
  version: string;
  guildCount: number;
  degraded: boolean;
}

/** Public, unauthenticated — throws ApiError('BOT_UNREACHABLE', ...) if the Bridge isn't configured/reachable. Never returns fabricated data in that case. */
export function getBotInfo(): Promise<BotInfo> {
  return apiFetch<BotInfo>('/api/bot');
}
